import { css } from "@linaria/core";
import { styled } from "@linaria/react";
import { isMobile } from "../../../@css-style";

export const ElContactUs = styled.section`
  width: 100%;
  display: flex;
  /* padding: 10px; */
  position: relative;
  justify-content: space-between;
  font-family: "Plus Jakarta Sans", sans-serif;
  font-weight: 100;
  font-style: normal;
  padding: 5em 0;
  background-repeat: no-repeat;
  background-position: right;
  ${isMobile} {
    padding: 2em 0;
  }
  * {
    font-family: "Plus Jakarta Sans", sans-serif;
  }
`;

export const ElContactUsContent = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
  padding: 10px;
  align-items: center;
  justify-content: center;
  /* background-color: #fff; */
  ${isMobile} {
    width: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;

export const ElColumn = styled.div<{ "data-color"?: string }>`
  max-width: 50%;
  width: 100%;
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  justify-content: end;
  gap: 20px;
  ${isMobile} {
    max-width: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;

export const ElColumnInside = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  justify-content: end;
  /* overflow: hidden; */
  border-radius: 20px;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
  /* padding: 20px; */
  background-color: #fff;
  position: relative;

  iframe {
    max-width: 100%;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const elMapBox = css`
  height: 100%;
  ${isMobile} {
    ${ElColumnInside} {
      height: 300px !important;
      position: relative;
      flex: none !important;
    }
  }
`;

export const ElHeaderTitle = styled.h2`
  /* font-size: 17px; */
  width: 100%;
  text-align: left;
  font-size: 23px;
  font-weight: 700;
  color: #fff;
  color: var(--theme-main-flat-dark-color);
`;
export const ElHeaderSubTitle = styled.h3`
  /* font-size: 17px; */
  font-size: 23px;
  width: 100%;
  text-align: left;
  color: var(--theme-main-flat-dark-color);
  font-weight: 500;
`;

export const ElBoxSubs = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 20px;
  padding: 20px;
`;

export const ElBoxSubsInside = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 10px;
`;

export const ElDetails = styled.p`
  width: 100%;
  text-align: left;
  font-size: 14px;
  font-weight: 400;
  color: var(--theme-main-flat-dark-color);
  word-break: break-word;
`;

export const ElSubTitle = styled.p`
  width: 100%;
  text-align: left;
  font-size: 17px;
  font-weight: 400;
  color: var(--theme-main-flat-dark-color);
`;

export const elGapContactUs = css`
  gap: 20px;
`;

export const elPad20 = css`
  padding: 20px;
  gap: 20px;
`;

export const elIfranme = css`
  /* position: absolute; */
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
`;

export const elHasBg = css`
  background-color: var(--theme-main-color);
  /* background-image: linear-gradient(135deg, #10575c 0%, var(--theme-main-color) 100%); */
  padding: 1em;
  border-radius: 10px;
  ${isMobile} {
    padding: 0;
  }
  * {
    color: #fff;
  }
`;

export const elHasBgGreen = css`
  background-color: var(--theme-main-green-color);
  /* background-image: linear-gradient(135deg, #10575c 0%, var(--theme-main-color) 100%); */
  padding: 1em;
  border-radius: 10px;
  ${isMobile} {
    padding: 0;
  }
  * {
    color: #fff;
  }
`;
